


































import UploadingList from '@/components/taskList/upload.vue'
import DownloadingList from '@/components/taskList/download.vue'
import UnzipingList from '@/components/taskList/Unzip.vue'
import CompressList from '@/components/taskList/CompressList.vue'
import FinishedUnzipCompress from '@/components/taskList/finishedUnzipCompress.vue'
import FinishedUpDownload from '@/components/taskList/finishedUpDownload.vue'
import { createComponent, ref } from '@vue/composition-api'
import { useRouter } from '@/hooks/common'
export default createComponent({
    components: {
        UploadingList,
        DownloadingList,
        UnzipingList,
        CompressList,
        FinishedUnzipCompress,
        FinishedUpDownload,
    },
    setup() {
        const router = useRouter()
        const activeName = ref('uploading')
        const handleClick = val => {
            // console.log(val)
        }
        const goPublic = () => {
            // public中离开路由时保存query的id
            if (sessionStorage.getItem('currentPage')) {
                const currentPage = sessionStorage.getItem('currentPage') as string
                router.push({ path: '/', query: { id: JSON.parse(currentPage).id } })
            } else {
                router.push({ path: '/' })
            }
        }
        return {
            activeName,
            handleClick,
            goPublic,
        }
    },
})
